import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TOKEN_KEY = "winez_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => (t ? localStorage.setItem(TOKEN_KEY, t) : localStorage.removeItem(TOKEN_KEY));

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const t = getToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export const DISABLED = "This account is disabled. Please contact support.";
export const STAFF_DISABLED = "This account is disabled. Please contact your company owner.";
export const NOTICE_KEY = "winez_notice";

api.interceptors.response.use(
  (r) => r,
  (err) => {
    const detail = err.response?.data?.detail;
    if (err.response?.status === 403 && (detail === DISABLED || detail === STAFF_DISABLED) && getToken()) {
      setToken(null);
      sessionStorage.setItem(NOTICE_KEY, detail);
      window.location.href = "/login";
    }
    if (err.response?.status === 401 && getToken() && !err.config.url.startsWith("/auth/")) {
      setToken(null);
      window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);

export function errorMessage(err, fallback = "Something went wrong. Please try again.") {
  const detail = err?.response?.data?.detail;
  if (!detail) return err?.message && !err.response ? "Network error. Please try again." : fallback;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return detail.msg || String(detail);
}

export async function downloadBlob(url, filename) {
  const res = await api.get(url, { responseType: "blob" });
  const href = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = href;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(href), 1500);
}

export function filenameFromHeaders(res, fallback) {
  const m = /filename="([^"]+)"/.exec(res.headers?.["content-disposition"] || "");
  return m ? m[1] : fallback;
}
